import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { FeedKey, GroupFragment, useGetGroupFollowersQuery } from 'api';
import { FollowToggle, GroupAvatar } from 'components';

import Tabs from './Tabs';

interface IProps {
  group: GroupFragment;
  isFollowing: boolean;
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  block: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: '50%',
  },
  container: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  lastItem: {
    marginRight: 12,
  },
}));

const MobileBanner: FC<IProps> = ({ group, isFollowing }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const backgroundColor = group.color_map.hex;
  const refetchQueryKey = useGetGroupFollowersQuery.getKey({
    data: { id: group.id, limit: 10, feed: FeedKey.Group },
  });

  function renderToggle() {
    return (
      <FollowToggle source={group} type={FeedKey.Group} refetchQueryKeys={[refetchQueryKey]}>
        {({ onClick }) => (
          <Button size="small" color="primary" variant="contained" onClick={onClick}>
            {t('common:join')}
          </Button>
        )}
      </FollowToggle>
    );
  }

  function renderTopRow() {
    return (
      <Grid container alignItems="center">
        <Grid item>
          <GroupAvatar square group={group} size={48} />
        </Grid>
        <Grid item>
          <div className={classes.block} style={{ backgroundColor }} />
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography title={group.title} color="textPrimary" variant="subtitle2" noWrap>
            {group.title}
          </Typography>
        </Grid>
        <Grid item className={classes.lastItem}>
          {renderToggle()}
        </Grid>
      </Grid>
    );
  }

  if (isFollowing) {
    return (
      <Paper>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Tabs group={group} />
          </Grid>
        </Grid>
      </Paper>
    );
  }

  return (
    <Paper className={classes.root}>
      <Grid className={classes.container} container alignItems="center">
        <Grid item xs>
          {renderTopRow()}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          <Tabs group={group} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MobileBanner;
